import { observer } from 'mobx-react-lite'
import { Button, DropdownContent, Typography } from 'shared/ui'
import { makeTextFieldAutoFocus, TextField } from 'shared/ui/TextField'
import { type OutboundSource } from 'entities/OutboundSource/model/OutboundSource'
import { OutboundSourcesDropdownContentItems } from 'widgets/SearchDropdown/ui/DropdownContent/OutboundSourcesDropdownContent/OutboundSourcesDropdownContentItems'
import { type SearchDropdownOutboundSourceStore } from 'widgets/SearchDropdown/store/searchDropdownOutboundSourceStore'
import styles from './styles.module.scss'

type IOutboundSourcesDropdownContentProps = {
  store: SearchDropdownOutboundSourceStore
  onChange?: (item: OutboundSource) => void
  width?: number
}

export const OutboundSourcesDropdownContent = observer(
  ({ store, onChange, width }: IOutboundSourcesDropdownContentProps) => {
    const { init, search, resetType, handleSearch, hasSelectedItems, maxLimit } = store

    const handleReset = () => {
      resetType()
      init()
    }

    return (
      <DropdownContent noPadding className={styles.wrap} width={width}>
        <div className={styles.searchWrap}>
          <TextField
            className={styles.search}
            variant='integrated'
            InputProps={{
              placeholder: 'Search outbound source',
            }}
            onChange={handleSearch}
            value={search}
            mainActions={[makeTextFieldAutoFocus({ withFocus: !search })]}
          />
        </div>
        {maxLimit && (
          <Typography
            variant='body-sm-medium'
            color='var(--content-primary-tertiary)'
            ariaLabel='OutboundSourceDropdownLimit'
            className={styles.limitInfo}
          >
            Select outbound source (up to {maxLimit})
          </Typography>
        )}

        <OutboundSourcesDropdownContentItems store={store} onChange={onChange} />

        {hasSelectedItems && (
          <div className={styles.clear}>
            <Button typeBtn={'text'} text={'Clear'} onClick={handleReset} />
          </div>
        )}
      </DropdownContent>
    )
  }
)
